"use strict";

module.exports = function (nameForErrorMessage, window) {
  if (!window) {
    // Do nothing for window-less documents.
    return;
  }

  window._virtualConsole.emit("jsdomError", new Error(`Not implemented: ${nameForErrorMessage}`));
};



//////////////////
// WEBPACK FOOTER
// ./~/jsdom/lib/jsdom/browser/not-implemented.js
// module id = 813
// module chunks = 0